import { PlanogramDetailSchema } from "@labeling-tools/api/atlas";
import { getPlanoDimension } from "../../utils/plano-related.utils";
import { OneLabelBox } from "./one-label-box/one-label-box.comp";
import { useActivePlanoProductInfoStore } from "../use-active-plano-product-info-store";

interface Props {
  planogram: PlanogramDetailSchema;
  callback?: (product_id: string | null) => void;
}

export const PlanoLabelBoxes = (props: Props) => {
  const { planogram, callback } = props;
  const planogramProducts = planogram?.products ?? [];
  const activePlanogramProductId = useActivePlanoProductInfoStore(
    (s) => s.productBoxInfo.planogram_product_id,
  );

  const planoDimension = getPlanoDimension(planogramProducts);

  return (
    <div className="absolute inset-0 size-full">
      {planogramProducts.map((planogramProduct) => {
        return (
          <OneLabelBox
            key={planogramProduct.id}
            planogramProduct={planogramProduct}
            planoDimension={planoDimension}
            isSelected={activePlanogramProductId === planogramProduct.id}
            callback={callback}
          />
        );
      })}
    </div>
  );
};
